import React, { useState } from 'react';
import styled from 'styled-components';
import theme from 'shared/assets/style/theme';
import Validators from 'shared/components/Form/InputValidator';
import ValidatorError from 'shared/components/Form/ValidatorError';
import AutoFormInput from '../../../../../../../components/AutoFormInput';
export default function MemberLoginFormHandler(props) {
  const { submitHandler, serverResponse, isLoading } = props;
  const [fields, setfileds] = useState(defaultMemberLoginValues);
  const { email, password, isValidEmail, isValidPassword, passwordHint } = fields;
  const isValidInput = !isLoading && email && isValidEmail && password && isValidPassword;

  const handleInputChange = field => event => {
    if (event.validated) {
      if (field === 'email') {
        setfileds({ ...fields, isValidEmail: event.validated, email: event.value });
      } else if (field === 'password') {
        if (Validators.LENGTH_GREATER_THAN(event.value, 6)) {
          setfileds({ ...fields, isValidPassword: event.validated, password: event.value, passwordHint: '' });
        } else {
          setfileds({ ...fields, isValidPassword: false, passwordHint: ValidatorError.LENGTH_GREATER_THAN });
        }
      }
    } else {
      if (field === 'email') {
        setfileds({ ...fields, isValidEmail: false });
      } else {
        setfileds({ ...fields, isValidPassword: false });
      }
    }
  };

  return (
    <>
      <FormRowHolder>
        <FormInputWrapper>
          <AutoFormInput
            customClassName="transparentInput"
            emitInput={handleInputChange('email')}
            value={email}
            label=""
            type="text"
            containerStyle={styles.inputContainer}
            validator={Validators.EMAIL}
            placeholder="Email"
            trimInput={true}
          />
        </FormInputWrapper>
        <FormInputWrapper>
          <AutoFormInput
            customClassName="transparentInput"
            customPeeker={styles.peeker}
            emitInput={handleInputChange('password')}
            value={password}
            label=""
            type="password"
            containerStyle={styles.inputContainer}
            validator={Validators.NOT_EMPTY}
            placeholder="Password"
          />
          {passwordHint && <PasswordHint>{passwordHint}</PasswordHint>}
        </FormInputWrapper>
      </FormRowHolder>
      {serverResponse && <ServerResponse>{serverResponse}</ServerResponse>}
      <LoginButtonWrapper>
        <LoginButton isValidInput={isValidInput} onClick={isValidInput ? submitHandler(email, password) : null}>
          LOG IN
        </LoginButton>
      </LoginButtonWrapper>
    </>
  );
}

const defaultMemberLoginValues = {
  email: '',
  password: '',
  passwordHint: '',
  isValidEmail: false,
  isValidPassword: false,
};

const PasswordHint = styled.div`
  font-size: 12px;
  margin: 0px 12px;
`;

const FormRowHolder = styled.div`
  display: flex;
  width: 100%;
`;

const FormInputWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const ServerResponse = styled.div`
  color: red;
  margin-top: 1em;
  text-align: center;
`;

const LoginButton = styled.div`
  cursor: pointer;
  font-size: 1.7rem;
  font-weight: 600;
  width: 181px;
  height: 59px;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px;
  background-image: url(${({ isValidInput }) =>
    isValidInput ? require(asset`RoundedRect_Pink@2x.png`) : require(asset`RoundedRect_Grey@2x.png`)});
`;

const LoginButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const styles = {
  inputContainer: {
    flex: 1,
    margin: 10,
    '& input': {
      background: theme.palette.common[33],
      color: 'white',
      border: `1px solid ${theme.palette.common[33]}`,
    },
  },
  peeker: {
    position: 'absolute',
    top: '48%',
    right: 16,
    zIndex: 2,
    cursor: 'pointer',
  },
};

